import React from "react"
import styled from "styled-components"
import { graphql } from "gatsby"
import Content from "components/Content"
import tw from "twin.macro"
import ResponsiveImage from "components/ResponsiveImage"
import { PrismicRichText } from "@prismicio/react"

const StyledQuoteWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledCite = styled.div`
  margin-left: auto;
  margin-right: 4rem;
  ${tw`ml-auto mr-8 mb-20 flex flex-row-reverse items-center text-right`}

  .person {
    margin-left: 3rem;
  }

  p {
    ${tw`m-0`}
  }

  a {
    ${tw`text-brand-500`}
  }
`

function Quote({ content, ...props }) {
  const {
    quote,
    name,
    company_name,
    role_position,
    client_logo,
    profile_pic,
    testimonial_video,
    ...rest
  } = content

  return (
    <StyledQuoteWrapper>
      <div tw="flex items-center">
        <Content
          content={quote}
          isQuote
        />
      </div>

      <StyledCite>
        <div className="person">
          <span tw="flex items-center">
            <span tw="mr-2">— </span>
            <Content
              content={name}
            />
          </span>
          <span tw="flex items-center text-xl">
            <Content
              content={role_position}
            />
          </span>
          <span tw="flex items-center text-xl">
            <Content
              content={company_name}
            />
          </span>
        </div>
        <span tw="w-24 h-24 flex place-content-center shadow-card rounded-full overflow-hidden">
          <ResponsiveImage tw="my-auto object-fill" img={client_logo} />
        </span>
        {profile_pic.url && (
          <span tw="w-36 h-36 -mt-12 -mr-8 flex place-content-center shadow-card rounded-full overflow-hidden">
            <ResponsiveImage tw="my-auto object-fill" img={profile_pic} />
          </span>
        )}
      </StyledCite>
    </StyledQuoteWrapper>
  )
}

export default Quote

export const query = graphql`
  fragment TestimonialFragment on PrismicBlogPostDataBodyTestimonial {
    slice_type
    id
    primary {
      theme
      title {
        richText
        raw
      }
      role_position {
        richText
        raw
      }
      quote {
        richText
        raw
      }
      name {
        richText
        raw
      }
      eyebrow_headline {
        richText
        raw
      }
      description {
        richText
        raw
      }
      company_name {
        richText
        raw
      }
      client_logo {
        url
      }
      profile_pic {
        url
      }
      testimonial_video {
        url
      }
    }
  }
`
